import { ActivityIcon, GaugeIcon, NetworkIcon, RadioTowerIcon, ServerCogIcon, ShieldCheckIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: 'PROCESS CONTROL FUNDAMENTALS: CONTROL LOOPS, PROCESS DYNAMICS & FINAL CONTROL ELEMENTS',
    summary: 'A visual technical reference to how control loops work, from PV, SP and OP to process dynamics, controller action and control valves.',
    icon: GaugeIcon,
  },
  {
    number: '02',
    title: 'PID CONTROL & LOOP TUNING: P, I, D, TUNING METHODS & ADVANCED REGULATORY CONTROL',
    summary: 'A visual technical reference to PID actions, tuning methods, oscillation diagnosis and cascade, ratio, feedforward and override strategies.',
    icon: ActivityIcon,
  },
  {
    number: '03',
    title: 'DISTRIBUTED CONTROL SYSTEMS (DCS): ARCHITECTURE, CONFIGURATION & PLANT OPERATIONS',
    summary: 'A visual technical reference to DCS layers, redundancy, I/O, function blocks, sequences, change management and diagnostics.',
    icon: ServerCogIcon,
  },
  {
    number: '04',
    title: 'SCADA, RTUs & TELEMETRY: SUPERVISORY CONTROL OF DISTRIBUTED ASSETS',
    summary: 'A visual technical reference to SCADA architecture, RTUs, polling and report by exception, telemetry media and remote-site supervision.',
    icon: RadioTowerIcon,
  },
  {
    number: '05',
    title: 'INDUSTRIAL COMMUNICATIONS & PROTOCOLS: FIELDBUS, MODBUS, PROFIBUS, DNP3, OPC & INDUSTRIAL NETWORKS',
    summary: 'A visual technical reference to RS-485, Modbus, HART, fieldbus, DNP3, IEC 61850, OPC UA, MQTT and industrial Ethernet.',
    icon: NetworkIcon,
  },
  {
    number: '06',
    title: 'HMI, ALARM MANAGEMENT, HISTORIANS, OT CYBERSECURITY & TROUBLESHOOTING',
    summary: 'A visual technical reference to high-performance HMI, alarm rationalization, historians, defensive OT security and systematic troubleshooting.',
    icon: ShieldCheckIcon,
  },
];
